// Real-time zone alerts are rendered by vue-toastification in its OWN Vue app, which
// does not get the i18n plugin ($t / useI18n are not there), so these read the global
// i18n instance. The zone name and the seconds keep their <i>/<b> markup: the
// translated sentence is split around them instead of going through v-html (a zone
// name is user data).
import { i18n } from '@/i18n'

const MARK = '\u0001'

// alertParts('notifications.alerts.waiting', { zone, time })
//   -> [{ text: 'Visitors have been queuing for over ' }, { name: 'time', value: 42 }, …]
export function alertParts(key, values) {
  const names = Object.keys(values)
  const params = Object.fromEntries(names.map((n, i) => [n, `${MARK}${i}${MARK}`]))
  return i18n.global.t(key, params)
    .split(new RegExp(`${MARK}(\\d+)${MARK}`))
    .map((piece, i) => (i % 2
      ? { name: names[Number(piece)], value: values[names[Number(piece)]] }
      : { text: piece }))
    .filter((p) => p.name || p.text)
}
